


























import { Prop, Component, Vue } from "vue-property-decorator";
import EstimateRow from "./EstimateRow.vue";

@Component({
  components: {
    EstimateRow
  }
})
export default class EstimateHeader extends Vue {
  @Prop({ required: true }) fields!: HeaderItem[];
  @Prop({ required: true }) styleGridColumn!: string;
  @Prop({ required: true }) isShowNoteColumn!: boolean;

  getGridStyle(spanRow: number) {
    let style: any = {};
    if (spanRow === 0) {
      style.gridRow = "span 2";
    } else {
      style.gridColumn = `span ${spanRow}`;
    }
    return style;
  }
}
